import React from "react";
import { Container } from "@pixi/react";
import ButtonSound from "../Buttons/ButtonSound";
import ButtonMenu from "../Buttons/ButtonMenu";
import { usePopiToolbarDimensions } from "../../../../Hooks/usePopiToolbarDimensions";
import { useDimensions } from "../../../../Contexts/DimensionsContext";
import PopiClock from "../../shared/Other/PopiClock";
import CompanyLogo from "../CompanyLogo/CompanyLogo";
import LogoLandscape from "../../shared/Logos/LogoLandscape";
import ButtonGameRules from "../Buttons/ButtonGameRules";
import ButtonPaytable from "../Buttons/ButtonPaytable";
import ButtonSettings from "../Buttons/ButtonSettings";
// import ButtonHome from "../Buttons/ButtonHome";
import LogoPortrait from "../../shared/Logos/LogoPortrait";

const ToolbarTop = () => {
  const toolbar = usePopiToolbarDimensions();
  const { dimensions } = useDimensions();

  return (
    <Container
      name="secondary_toolbar_top"
      x={(dimensions.width - toolbar.width) / 2}
      sortableChildren={true}
      y={0}
    >
      <ButtonMenu />
      <ButtonGameRules />
      <ButtonPaytable />
      <ButtonSettings />
      {/* <ButtonHome /> */}

      <CompanyLogo toolbar={toolbar} />
      <ButtonSound toolbar={toolbar} />
      <PopiClock toolbar={toolbar} />

      <LogoLandscape toolbar={toolbar} />
      <LogoPortrait toolbar={toolbar} />
    </Container>
  );
};

export default ToolbarTop;
